import { llmRequest } from "./client";
import { VACANCY_ANALYSIS_SYSTEM_PROMPT } from "./prompts";

export interface AnalysisResult {
  match_score: "strong" | "good" | "partial" | "weak" | "no_fit";
  match_rationale: string;
  confirmed_requirements: string[];
  gap_questions: {
    id: string;
    requirement: string;
    classification: "inferred" | "gap";
    inference_basis?: string;
    question_en: string;
    question_nl: string;
  }[];
}

const schema = {
  type: "object",
  properties: {
    match_score: { type: "string", enum: ["strong", "good", "partial", "weak", "no_fit"] },
    match_rationale: { type: "string" },
    confirmed_requirements: { type: "array", items: { type: "string" } },
    gap_questions: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "string" },
          requirement: { type: "string" },
          classification: { type: "string", enum: ["inferred", "gap"] },
          inference_basis: { type: "string" },
          question_en: { type: "string" },
          question_nl: { type: "string" },
        },
        required: ["id", "requirement", "classification", "question_en", "question_nl"],
      },
    },
  },
  required: ["match_score", "match_rationale", "confirmed_requirements", "gap_questions"],
};

export async function analyzeVacancyMatch(
  _apiKey: string,   // kept for call-site compat during transition; ignored
  _model: string,
  cvText: string,
  vacancyJson: string,
  systemPrompt?: string | null,
): Promise<AnalysisResult> {
  return llmRequest<AnalysisResult>({
    systemPrompt: systemPrompt || VACANCY_ANALYSIS_SYSTEM_PROMPT,
    userContent: [
      {
        type: "text",
        text: `Target Vacancy details (JSON):\n${vacancyJson}\n\nCandidate CV Text:\n${cvText}\n\nPlease analyze the match and output the structured gap questions.`,
      },
    ],
    schema,
  });
}
